<template>
  <article class="analysisA" :class="{hidden: !pageStatus.isLoaded}">
    <ul class="tab-service-detail">
      <li v-for="(item, index) in tabList" @click="onShiftTab(item)" :class="{on:item.on}" :key="index">
        <a href="javascript:void(0);">{{item.name}}</a>
      </li>
    </ul>
    <div class="blank"></div>
    <div class="car-all">
      <!-- 今日、昨日/本月、上个月 -->
      <cell :title="storeName" class="top-title">
        <span slot="after-title" class="title-date">|&nbsp;&nbsp;{{this.showDate}}</span>
        <button
          slot="child"
          class="btn-default btn-margin"
          v-for="(item, index) in tabObj[tabStatus]"
          :key="index"
          :class="{'btn-select': period === item.key}"
          @click.stop="selectTab(item.key)"
        >
          {{item.name}}
        </button>
      </cell>

      <div class="out-chart">
        <chart
          id="myChart"
          :options="option"
          theme="lineChart"
          auto-resize
          class="mychart"
        >
        </chart>
      </div>

      <!-- 概况数据 -->
      <p class="table-title">概况</p>
      <div class="store-box">
        <flexbox :gutter="0" wrap="wrap">
          <flexbox-item
            :span="1/3"
            v-for="(item, index) in insTotal"
            :class="[{'seperate-line': index % 3 !== 0, 'cut-line': insTotal.length - index > insTotal.length - 3}, 'store-box-cell']"
            :key="index"
          >
            <span class="store-box-num">{{item.data | transferValue}}</span>
            <span>{{item.name}}</span>
          </flexbox-item>
        </flexbox>
      </div>

      <!-- 离店车次饼图 -->
      <p class="table-title">离店车次详情</p>
      <chart
        :options="optionLeaveCar"
        theme="pieChart"
        auto-resize
        class="mypiechart"
        v-if="optionEmpty"
      >
      </chart>
      <p style="color: #ddd;text-align: center; padding: 10px 0 30px 0;" v-else>暂无数据</p>

      <!-- 审批放行饼图 -->
      <p class="table-title">审批放行详情</p>
      <chart
        :options="optionApprovalCar"
        theme="pieChart"
        auto-resize
        class="mypiechart"
        v-if="optionEmpty"
      >
      </chart>
      <p style="color: #ddd;text-align: center; padding: 10px 0 30px 0;" v-else>暂无数据</p>

      <p style="color: #999999; text-align: center; padding-top: 10px;">注：若销售和售后放行均为0台次说明未配置相应权限</p>
      <p style="color: #E4E4E4; text-align: center; padding-top: 5px;">统计截止时间：{{this.endTime}}</p>

      <!-- 集团数据 -->
      <div v-if="hasGroupAuth">
        <p class="table-title">门店统计</p>
        <component-table
          :titles = "tableTitle"
          :lists="storesDetail"
          :keyArray="keyArray"
          :mainTitle="mainTitle"
          mainName="store_name"
          :date="day"
          :flag="flagA"
          :isDay="tabList[0].on && tabList[0].id === 'date'"
          class="table-scroll"
          url="/manageAnalysis/carVisitDetail">
        </component-table>
      </div>
    </div>
  </article>
</template>
<script>
// echarts 组件是否加载完毕
import theme from './myLineChart.json'
import util from '../../common/util'
// import cookie from '../../common/cookie'
import ComponentTable from './ComponentTable'
import {
  Cell,
  Flexbox,
  FlexboxItem
} from '@lx-frontend/cvux'

let status = {}
status.isLoaded = false
const Chart = () => import(/* webpackChunkName: "ECharts" */ 'vue-echarts').then(ECharts => {
  ECharts.registerTheme('lineChart', theme)
  ECharts.registerTheme('pieChart', theme)
  status.isLoaded = true
  return ECharts
})
export default {
  components: {
    Cell,
    Flexbox,
    FlexboxItem,
    Chart,
    ComponentTable
  },
  data() {
    return {
      pageStatus: status, // 状态信息
      storeName: '',
      hasGroupAuth: false,
      option: {}, // 曲线图数据与设置
      keyArray: ['park_visit_times', 'workshop_visit_times', 'park_exit_times', 'park_visit_cars', 'workshop_visit_cars', 'park_exit_cars'], // 集团视图门店统计对应key值
      mainTitle: { name: '门店' },
      // 集团视图门店统计标题
      tableTitle: [
        { name: '进店车次' },
        { name: '进车间车次' },
        { name: '离店车次' },
        { name: '进店车辆' },
        { name: '进车间车辆' },
        { name: '离店车辆' }
      ],
      tabList: [{
        id: 'date',
        name: '日',
        on: true
      }, {
        id: 'month',
        name: '月',
        on: false
      }],
      day: util.formatTime(new Date(), 'yyyy-MM-dd'), // 获取当前日期
      storeId: '', // 参数门店ID
      hoursChart: [], // 数据图数据
      storesDetail: [], // //门店表格数据
      visitsCount: [], // 进店车次
      carEnters: [], // 进车间车次
      carLeaves: [], // 离店车次
      hour: [],
      flagA: true, // 默认日期是今天/本月,true => 今天/本月, false = > 昨天/上个月
      // 定义今日、昨日、本月、上个月数据结构
      tabObj: {
        date: [
          {
            key: 'today',
            name: '今日'
          }, {
            key: 'yesterday',
            name: '昨日'
          }
        ],
        month: [
          {
            key: 'this_month',
            name: '本月'
          }, {
            key: 'last_month',
            name: '上个月'
          }
        ]
      },
      insTotal: [ // 概览数据结构
        {
          'data': {
            'itemName': 'park_visit_cars', // 对应接口key值
            'total': 0, // 具体数据，需调接口获取数据再赋值给这个字段
            'type': 'default' // type三种类型：default,price,rate，每种类型展示略有区别，在transferValue（）函数里定义
          },
          'name': '进店车辆' // 展示名称
        }, {
          'data': {
            'itemName': 'workshop_visit_cars',
            'total': 0,
            'type': 'default'
          },
          'name': '进车间车辆'
        }, {
          'data': {
            'itemName': 'park_exit_cars',
            'total': 0,
            'type': 'default'
          },
          'name': '离店车辆'
        }, {
          'data': {
            'itemName': 'park_visit_times',
            'total': 0,
            'type': 'default'
          },
          'name': '进店车次'
        }, {
          'data': {
            'itemName': 'workshop_visit_times',
            'total': 0,
            'type': 'default'
          },
          'name': '进车间车次'
        }, {
          'data': {
            'itemName': 'park_exit_times',
            'total': 0,
            'type': 'default'
          },
          'name': '离店车次'
        }
      ],
      summary: {}, // 概览数据
      period: 'today', // 默认日期是今天/本月
      tabStatus: 'date', // 每日/每月数据
      showDate: '', // 展示当前数据日期or月份
      optionLeaveCar: {}, // 离店车次饼图
      optionApprovalCar: {}, // 审批放行饼图
      optionEmpty: false, // 饼图是否存在
      normalExit: {}, // 审批放行
      abnormalExit: {}, // 异常放行
      freeExit: {}, // 免放行
      exitComponentsTotal: '', // 总数
      endTime: '' // 统计截止时间
    }
  },
  async created() {
    await this.setParams()
    // this.storeId = +cookie.getCookie('store_id')
    // // 是否有权限查看集团范围数据
    // this.hasGroupAuth = cookie.getCookie('view_group') === 'true' ? 1 : false
    // 离店车次详情
    this.leaveCar = [
      {
        key: 'total', // normal_exit.total
        name: '审批放行',
        value: 0
      }, {
        key: 'whitelist',
        name: '白名单',
        value: 0
      }, {
        key: 'blacklist',
        name: '黑名单',
        value: 0
      }, {
        key: 'other', // abnormal_exit.other
        name: '异常放行',
        value: 0
      }, {
        key: 'free',
        name: '免放行',
        value: 0
      }
    ]
    // 审批放行详情
    this.approvalCar = [
      {
        key: 'sales_car_exit',
        name: '销售接待',
        value: 0
      }, {
        key: 'service_car_exit',
        name: '售后接待',
        value: 0
      }, {
        key: 'other', // normal_exit.other
        name: '其他接待',
        value: 0
      }
    ]
    this.selectTab(this.period)
  },
  methods: {
    async setParams () {
      try {
        const { code, data, message } = await this.$rest.dataAnalysis.getCarAuth()
        if (code !== 0) {
          this.showToast(message)
          return
        }

        this.storeId = +data.store_id
        this.hasGroupAuth = data.view_group
      } catch (e) {
        this.showToast(e.message)
      }
    },
    getDateDetail(vl) {
      // 门店概况数据，给insTotal数组中的total赋值
      if (vl) {
        this.insTotal.forEach((item) => {
          item.data.total = vl[item.data.itemName] || 0
        })
      }
    },
    queryData(chooseDate) {
      let tmp = {}
      if (this.hasGroupAuth) {
        tmp = {
          date: chooseDate
        }
      } else {
        tmp = {
          date: chooseDate,
          store_id: this.storeId
        }
      }
      let params = tmp
      let DayOrMonth = ''
      let tabDate = true // 当前选中tab是日数据
      if (this.tabList[0].on && this.tabList[0].id === 'date') {
        DayOrMonth = this.$rest.dataAnalysis.getCarDaily // 调用日数据接口
      } else {
        DayOrMonth = this.$rest.dataAnalysis.getCarMonthly // 调用月数据接口
        tabDate = false
      }
      DayOrMonth(params).then(res => {
        if (res.code === 0) {
          let dateObj = {}
          let pieObj = {}
          let selectDate = ''
          let allStores = {}
          this.storesDetail = []
          this.carVisit = res.data
          selectDate = Object.keys(this.carVisit)[0] || '' // 获取数据日期
          this.showDate = tabDate ? selectDate : selectDate.slice(0, 7)
          dateObj = Object.values(this.carVisit)[0]
          this.hoursChart = tabDate ? dateObj.hours_detail : dateObj.days_detail // 曲线图刻度与数据
          allStores = dateObj.stores_detail // 全部门店数据
          // 筛选出全部数据不为零的门店
          allStores.forEach(item => {
            let showStore = false
            this.keyArray.find(key => {
              if (item[key] !== 0) {
                showStore = true
              }
            })
            if (showStore) {
              this.storesDetail.push(item)
            }
          })
          this.summary = tabDate ? dateObj.today_sum : dateObj.month_sum // 概览数据
          pieObj = dateObj.exit_components // 饼图数据
          this.exitComponentsTotal = pieObj.total
          this.normalExit = pieObj.normal_exit // 审批放行
          this.abnormalExit = pieObj.abnormal_exit // 异常放行
          this.freeExit = pieObj.no_process_exit // 免放行
          // 是否展示饼图
          if (this.exitComponentsTotal) {
            // 离店车次详情饼图数据
            this.leaveCar.forEach(vl => {
              if (vl.key === 'total') {
                vl.value = this.normalExit.total
                return
              }
              if (vl.key === 'free') {
                vl.value = this.freeExit.total
                return
              }
              vl.value = this.abnormalExit[vl.key]
            })
            // 审批放行详情饼图数据
            this.approvalCar.forEach(vl => {
              vl.value = this.normalExit[vl.key]
            })
            this.optionLeaveCar = this.getEchartData(this.leaveCar)
            this.optionApprovalCar = this.getEchartData(this.approvalCar)
            this.optionEmpty = true
          } else {
            this.optionEmpty = false
            // 选项为空时echart不加载,页面直接展示
            this.pageStatus.isLoaded = true
          }
          this.getDateDetail(this.summary) // 概览赋值
          this.storeName = this.hasGroupAuth ? '车辆进出店' : dateObj.store_name // 店名
          this.cleanChart()
          this.hoursChart.forEach(v => {
            this.visitsCount.push(v.park_visit_times)
            this.carEnters.push(v.workshop_visit_times)
            this.carLeaves.push(v.park_exit_times)
            let hourX = tabDate ? v.hour + ':00' : v.date.replace(/-/g, '/').slice(5)
            this.hour.push(hourX)
          })
          this.option = this.getEchart(this.hour, this.visitsCount, this.carEnters, this.carLeaves)
        } else {
          this.showToast(res.message)
        }
      })
      this.option = this.getEchart(this.hour, this.visitsCount, this.carEnters, this.carLeaves)
    },
    // 折线图
    getEchart(time, visits, enters, leaves) {
      let chartData = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        title: {
          text: '趋势图',
          textStyle: {
            color: '#666',
            fontSize: 13,
            fontWeight: 'normal'
          }
        },
        legend: {
          bottom: 10,
          data: [{
            name: '进店车次'
          }, {
            name: '进车间车次'
          }, {
            name: '离店车次'
          }]
        },
        xAxis: {
          type: 'category', // 坐标轴类型
          boundaryGap: false, // 坐标轴两边留白策略
          data: time // this.hour
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: '进店车次',
          type: 'line',
          data: visits, // this.visitsCount,
          markPoint: {
            data: [
              { type: 'max', name: '最大值' }
            ]
          }
        }, {
          name: '进车间车次',
          type: 'line',
          data: enters // this.carEnters
        }, {
          name: '离店车次',
          type: 'line',
          data: leaves // this.carLeaves
        }]
      }
      return chartData
    },
    // 饼图
    getEchartData(list) {
      let chartData = {
        tooltip: { // 点击提示name占比和对应value
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        color: ['#63d29d', '#63c9d2', '#6085ff', '#bc93ff'],
        series: [{
          type: 'pie',
          radius: '70%',
          center: ['50%', '50%'],
          data: list,
          itemStyle: {
            normal: {
              borderWidth: list.length === 1 ? 0 : 3,
              borderColor: '#fff'
            }
          }
        }]
      }
      return chartData
    },
    onShiftTab (item) {
      if (this.tabStatus === item.id) return false
      this.tabList.forEach((tab) => {
        if (item.id === tab.id) {
          tab.on = true // 月或日被选中
          this.tabStatus = tab.id // 赋值tabStatus当前被选中值
          this.period = tab.id === 'month' ? 'this_month' : 'today' // 转换日/月tab时默认选项今日/本月
          this.selectTab(this.period)
        } else {
          tab.on = false
        }
      })
    },
    // 今日、昨天/本月、上个月切换
    selectTab(key) {
      this.period = key
      switch (key) {
        case 'today':
          this.day = util.formatTime(new Date(), 'yyyy-MM-dd')
          this.endTime = util.formatTime(new Date(), 'yyyy年MM月dd日 hh:mm:ss')
          this.flagA = true
          break
        case 'yesterday':
          let yesterday = new Date(new Date() - 24 * 60 * 60 * 1000)
          this.day = util.formatTime(yesterday, 'yyyy-MM-dd')
          this.endTime = util.formatTime(yesterday, 'yyyy年MM月dd日 23:59:59')
          this.flagA = false
          break
        case 'this_month':
          this.day = util.formatTime(new Date(), 'yyyy-MM-dd')
          this.endTime = util.formatTime(new Date(), 'yyyy年MM月dd日 hh:00:00')
          this.flagA = true
          break
        case 'last_month':
          let today = util.formatTime(new Date(), 'yyyy-MM')
          let date = new Date()
          let endDate = new Date(date.getFullYear(), date.getMonth(), 0).getDate()
          this.day = util.getLastMonth(today) + '-' + endDate
          this.endTime = util.formatTime(this.day, 'yyyy年MM月dd日 23:59:59')
          this.flagA = false
          break
      }
      this.cleanDataDetail()
      this.cleanChart()
      this.queryData(this.day)
    },
    // 初始化概览数据
    cleanDataDetail() {
      this.insTotal.forEach(item => {
        if (item) {
          item.data.total = 0
        }
      })
    },
    cleanChart() {
      this.visitsCount = []
      this.carEnters = []
      this.carLeaves = []
      this.hour = []
    }
  },
  filters: {
    // 转换数据展示格式
    transferValue (obj) {
      obj.total = obj.total || 0
      switch (obj.type) {
        case 'price':
          return (obj.total / 100).toFixed(2) // 转换价格数据
        case 'rate':
          return util.accMul(obj.total, 100).toFixed(2) + '%' // 转换百分率数据
        default:
          return obj.total
      }
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
@import "../../stylesheets/modules/data/carData.less";
</style>
